import * as React from "react";

import { ILoaderProps } from "../domene"
import { appContext } from "../App/appContext"
import { getUrlParam } from "../Component/url"

import { RouteComponent } from "./RouteComponent";

export abstract class ModellComponent<TModel> extends RouteComponent {

    protected getId() { return +this.props.params["id"]; }

    protected constructor(props: ILoaderProps) { super(props); }

    renderPossiblyNotLoaded(): JSX.Element | null {
        return this.renderWithModel(this.getModel());
    }

    getModel(): TModel | undefined {
        return this.laster.last<TModel>(this.getModelPath());
    }

    protected abstract getModelPath(): string;

    protected abstract renderWithModel(model: TModel | undefined): JSX.Element | null;
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/ModellComponent.tsx